import Tool from './Tool';
import ToolDelete from './ToolDelete';
import ToolSelectAll from './ToolSelectAll';

class ToolClearCanvas extends Tool {
  static toolName = 'Clear canvas';

  static action({ controller, selection }) {
    if (
      window.confirm('Are you sure you want to delete everything on the canvas')
    ) {
      ToolSelectAll.action({ controller, selection });
      ToolDelete.action({ controller, selection });
    }
  }

  static enabled() {
    return true;
  }
}

export default ToolClearCanvas;
